
export const bookriot = [
    "Read a biography of an author you admire.",
    "Read a book set in a bookstore.",
    "Read any book from the Women’s Prize shortlist/longlist/winner list.",
    "Read a book in any genre by a POC that’s about joy and not trauma.",
    "Read an anthology featuring diverse voices.",
    "Read a nonfiction YA comic.",
    "Read a romance where at least one of the protagonists is over 40.",
    "Read a classic written by a POC.",
    "Read the book that’s been on your TBR the longest.",
    "Read a political thriller by a marginalized author (BIPOC, or LGBTQIA+).",
    "Read a book with an asexual and/or aromantic main character.",
    "Read an entire poetry collection.",
    "Read an adventure story by a BIPOC author.",
    "Read a book whose movie or TV adaptation you’ve seen (but haven’t read the book).",
    "Read a new-to-you literary magazine (print or digital).",
    "Read a book recommended by a friend with different reading tastes.",
    "Read a memoir written by someone who is trans or nonbinary.",
    "Read a “Best _ Writing of the year” book for a topic and year of your choice.",
    "Read a horror novel by a BIPOC author.",
    "Read an award-winning book from the year you were born.",
    "Read a queer retelling of a classic of the canon, fairytale, folklore, or myth.",
    "`Read a history about a period you know little about.",
    "Read a book by a disabled author.",
    "Pick a challenge from any of the previous years’ challenges to repeat!"
  ];
